module.exports = __webpack_public_path__ + "img/vrart_balloon2.cbb90e21.svg";